import { Box, Divider, FormControl, IconButton, Modal, TextField } from "@mui/material";
import { Certificate } from "../Certificate";
import { useState } from "react";
import { toast } from "react-toastify";
import { ICertificate } from "../../entities/certificates";
import { deleteDiplomaFolder, deleteDiplomaFromSearch, getCertificatesByFilters } from "../../lib/store/projects/thunks";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppDispatch, IState } from "../../lib/store";
import { LoadingButton } from "@mui/lab";
import { useForm, Controller } from "react-hook-form";
import { MAPPING_METADATA_KEYS_TO_LABEL } from "../../lib/referentiel";
import { GlobalSearchTable } from "../GlobalSearchTable";
import { certificatesTableDataMapper, getCertificate } from "../../lib/helper";
import { ICertificateData } from "../../entities/table";
import LeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { ICertificateDTO } from "../../entities/projects";
import ConfirmationDialog from "../ConfirmationDialog";

const filters = [
    'ine',
    'matricule',
    'nom',
    'prenoms',
    'date_naiss',
    'grade',
    'annee_obtention'
]
const getInstitution = (c: ICertificateDTO): string => {
    if (!c || Object.keys(c).length === 0) return '';
    let data: any;
    const year = Object.keys(c)[0];
    data = c[year];
    const grade = Object.keys(data)[0];
    data = data[grade];
    const program = Object.keys(data)[0];
    data = data[program];
    return data[0]["metadata"]["institution"]
}
  
const Filter: React.FC<{submit: (filters: Record<string, string>) => void, loading: boolean}> = ({submit, loading}) => {
    const { control, handleSubmit } = useForm();
    return (
        <Box padding={5} pt={1} component="form" onSubmit={handleSubmit(submit)} display="flex" flexDirection="column" gap={2} className="color-chart">
            <Box padding={5} pt={1} component="form" onSubmit={handleSubmit(submit)} display="flex" flexDirection="row" flexWrap="wrap" gap={2} className="color-chart">
                {filters.map((f) => (
                    <Controller
                        key={f}
                        name={f}
                        control={control}
                        defaultValue=""
                        render={({ field }) => 
                            <FormControl sx={{minWidth: 120 }}>
                                <TextField 
                                    onChange={field.onChange}
                                    size="medium"
                                    variant="standard"
                                    value={field.value} label={MAPPING_METADATA_KEYS_TO_LABEL[f]}
                                />
                            </FormControl>
                        }
                    />
                ))}
            </Box>
            <LoadingButton loading={loading} fullWidth type="submit" variant="outlined" color="inherit">Rechercher</LoadingButton>
        </Box>
    )
}

const Component: React.FC<{open: boolean, close: () => void}> = ({open, close}) => {
    const dispatch = useDispatch<AppDispatch>();
    const instituion = useSelector((state: IState) => getInstitution(state.projects.certificates), shallowEqual);
    const [certificates, setCertificates] = useState<ICertificate[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const [currentCert, setCurrentCert] = useState<ICertificateData | null>(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState<ICertificateData | null>(null);

    const search = (filters: Record<string, string>) => {
        setLoading(true);
        filters['institution'] = instituion;
        dispatch(getCertificatesByFilters(filters)).unwrap()
            .then((certificates) => {setCertificates(certificates); console.log(certificates)})
            .catch(() => toast.error('une erreur est survenue lors du chargement des certificats. Veuillez contacter le support pour plus d\infos.'))
            .finally(() => setLoading(false));
    }

    const onDelete = (row: ICertificateData) => {
      setSelectedRow(row);
      setOpenDeleteModal(true);
    }

    const deleteAction = (row: ICertificateData) => {
      setDeleteLoading(true);
      dispatch(deleteDiplomaFromSearch({institution: row.institution!, year: row.annee_obtention!, grade: row.grade!, program: row.program!, hash: row.hash!}))
          .then(() => {
            toast.success('dossier supprimé avec succès');
            setCertificates(certificates?.filter((c) => c.hash !== row.hash));
          })
          .catch(() =>  toast.error('Une erreur est survenue ... veuillez contacter le support si l\'erreur persiste.'))
          .finally(() => {
            setDeleteLoading(false);
            setOpenDeleteModal(false);
          });
    }
    return (
        <Modal  
            style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            open={open}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box 
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                gap={3}
                sx={{background: 'white', p: 1, pt: 0, height: '90%', width: '90%'}}
            >
            {
                currentCert ? (
                    <Box display="flex" flexDirection="column" overflow="scroll" p={2} pt={0} width="80%">
                        <Box display="flex" flexDirection="row" justifyContent="left">
                            <IconButton size="large" onClick={() => setCurrentCert(null)} ><LeftIcon /></IconButton>
                        </Box>
                        <Certificate certificate={getCertificate(currentCert.hash!, certificates!)} />
                    </Box>
                ) : (
                    <Box display="flex" flexDirection="column" overflow="scroll" p={2} pt={0} width="80%">
                        <Filter submit={search} loading={loading} />
                        {certificates && certificates.length > 0 && (<GlobalSearchTable rows={certificatesTableDataMapper(certificates)} onRowClick={(row) => setCurrentCert(row)} onDelete={onDelete} />)}
                    </Box>
                )}
                <ConfirmationDialog actionLabel="Suppression" loading={deleteLoading} open={openDeleteModal} close={() => setOpenDeleteModal(false)} action={() => deleteAction(selectedRow!)}/>
            </Box>
    </Modal>
    )
}

export default Component;